import Vue from 'vue'
import MutationTypes from './mutations-types'

export default {
  [MutationTypes.SET_JOBS](state, jobs) {
    state.jobs = [...jobs]
  },

  [MutationTypes.UPDATE_JOB](state, jobUpdate) {
    const index = state.jobs.findIndex(job => job.job_id == jobUpdate.job_id)

    if (false === index || index < 0) {
      return
    }

    const updatedObj = {...state.jobs[index], ...jobUpdate}

    Vue.set(state.jobs, index, updatedObj)
  },

  [MutationTypes.ADD_JOB](state, newJob) {
    state.jobs = [...state.jobs, newJob]
  },

  [MutationTypes.REMOVE_JOB](state, jobId) {
    state.jobs = state.jobs.filter(job => job.job_id !== jobId)
  },

  [MutationTypes.REMOVE_SUBTASKS_BY_PARENT_JOB_ID](state, parentJobId) {
    state.jobs = state.jobs.filter(job => job.parent_job_id != parentJobId)
  },

  [MutationTypes.SET_JOB_DEFINITIONS](state, jobDefinitions) {
    state.jobDefinitions = [...jobDefinitions]
  },

  [MutationTypes.ADD_JOB_DEFINITION](state, newJobDefinition) {
    state.jobDefinitions = [...state.jobDefinitions, newJobDefinition]
  },

  [MutationTypes.UPDATE_JOB_DEFINITION](state, jobDefinitionUpdate) {
    const index = state.jobDefinitions.findIndex(jd => jd.id == jobDefinitionUpdate.id)

    if (false === index || index < 0) {
      return
    }

    const updatedObj = {...state.jobDefinitions[index], ...jobDefinitionUpdate}

    Vue.set(state.jobDefinitions, index, updatedObj)
  },

  [MutationTypes.REMOVE_JOB_DEFINITION](state, jobDefinitionId) {
    state.jobDefinitions = state.jobDefinitions.filter(jd => jd.id !== jobDefinitionId)
  },

  [MutationTypes.SET_POOL_STATUSES](state, jobPoolStatuses) {
    state.jobPoolStatuses = jobPoolStatuses
  },

  [MutationTypes.SET_FOCUSED_JOB_GROUP](state, focusedJobGroup) {
    state.focusedJobGroup = focusedJobGroup
  },

  [MutationTypes.SET_TEMP_DELIVERABLES](state, deliverables) {
    state.tempDeliverables = deliverables ? [...deliverables] : []
  },

  [MutationTypes.CLEAR_TEMP_DELIVERABLES](state) {
    state.tempDeliverables = []
  },
}
